// Screen size breakpoint for collapsible sidebar
export const TAB_SIZE = 992
